var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-breadcrumb',{staticClass:"bg-white mt-1",attrs:{"items":_vm.items}})
}
var staticRenderFns = []

export { render, staticRenderFns }